(function () {
  var COLOUR_MAP = {
    // Neutrals
    'black': '#1a1a1a',
    'white': '#f8f8f8',
    'cream': '#fffdd0',
    'ivory': '#fffff0',
    'beige': '#f0e8d8',
    'nude': '#e8c9a0',
    'natural': '#d4b896',
    'stone': '#b2a99a',
    'mushroom': '#c4b3a3',
    'mink': '#a08070',
    'taupe': '#b5a898',
    'off white': '#f5f0e8',
    // Greys & Metallics
    'grey': '#9e9e9e',
    'gray': '#9e9e9e',
    'light grey': '#d0d0d0',
    'dark grey': '#555555',
    'silver': '#c0c0c0',
    'metallic': '#b8b4b0',
    'gold': '#c5a258',
    'bronze': '#cd7f32',
    'copper': '#b87333',
    'rose gold': '#b76e79',
    // Browns & Tans
    'brown': '#795548',
    'tan': '#d2b48c',
    'camel': '#c19a6b',
    'cognac': '#9a4822',
    'chestnut': '#954535',
    'chocolate': '#3d1c02',
    'rust': '#b7410e',
    // Reds & Pinks
    'red': '#c0392b',
    'burgundy': '#800020',
    'wine': '#722f37',
    'cherry': '#de3163',
    'coral': '#ff6b6b',
    'pink': '#f48fb1',
    'blush': '#f9c4c4',
    'rose': '#e8a0b4',
    'fuchsia': '#ff006e',
    'hot pink': '#ff69b4',
    'magenta': '#c2185b',
    // Blues
    'blue': '#1565c0',
    'navy': '#001f5b',
    'cobalt': '#0047ab',
    'teal': '#008080',
    'turquoise': '#40e0d0',
    'aqua': '#00bcd4',
    'electric blue': '#0066ff',
    // Greens
    'green': '#388e3c',
    'emerald': '#50c878',
    'olive': '#808000',
    'khaki': '#c3b091',
    'sage': '#b2ac88',
    'mint': '#98ff98',
    // Purples
    'purple': '#7b1fa2',
    'violet': '#ee82ee',
    'lilac': '#c8a2c8',
    'lavender': '#e6e6fa',
    'plum': '#8e4585',
    // Yellows & Oranges
    'yellow': '#f9d71c',
    'mustard': '#e1ad01',
    'orange': '#e65100',
    'amber': '#ffbf00',
    // Multi / Special
    'multi': 'linear-gradient(135deg,#e74c3c,#3498db,#2ecc71,#f1c40f)',
    'multicolour': 'linear-gradient(135deg,#e74c3c,#3498db,#2ecc71,#f1c40f)',
    'multicolor': 'linear-gradient(135deg,#e74c3c,#3498db,#2ecc71,#f1c40f)',
    'clear': 'rgba(200,200,200,0.3)',
    'transparent': 'rgba(200,200,200,0.3)',
  };

  function getColour(label) {
    if (!label) return '#cccccc';
    var lower = label.toLowerCase().trim();
    if (COLOUR_MAP[lower]) return COLOUR_MAP[lower];
    var words = lower.split(/[\s-]+/);
    for (var i = 0; i < words.length; i++) {
      if (COLOUR_MAP[words[i]]) return COLOUR_MAP[words[i]];
    }
    return '#cccccc';
  }

  var MAX_SWATCHES = 3;

  function buildSwatches(items, currentHandle) {
    var html = '<div class="card-swatches__inner">';
    items.forEach(function (item, idx) {
      var isCurrent = item.handle === currentHandle;
      var colour = getColour(item.colorLabel);
      var isGradient = colour.indexOf('linear-gradient') === 0;
      var isExtra = idx >= MAX_SWATCHES;
      html +=
        '<a href="' + item.url + '"' +
        ' class="card-swatch' + (isCurrent ? ' is-active' : '') + (isExtra ? ' is-extra' : '') + '"' +
        ' title="' + (item.colorLabel || item.handle) + '"' +
        ' aria-label="' + (item.colorLabel || 'Colour option') + '"' +
        (isCurrent ? ' aria-current="true"' : '') +
        ' style="' + (isGradient ? 'background:' : 'background-color:') + colour + ';">' +
        '</a>';
    });
    if (items.length > MAX_SWATCHES) {
      html +=
        '<button type="button" class="card-swatches__more" data-swatch-expand' +
        ' aria-label="Show ' + (items.length - MAX_SWATCHES) + ' more colours">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">' +
        '<path d="M9 18l6-6-6-6"/>' +
        '</svg>' +
        '</button>';
    }
    html += '</div>';
    return html;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-swatch-expand]');
    if (!btn) return;
    e.preventDefault();
    var inner = btn.closest('.card-swatches__inner');
    if (inner) inner.classList.add('is-expanded');
  });

  function init() {
    var cards = document.querySelectorAll('[data-style-id]');
    if (!cards.length) return;

    var groups = {};

    cards.forEach(function (card) {
      var sid = card.dataset.styleId;
      if (!sid) return;
      var url = card.dataset.productUrl
        || (card.querySelector('.grid-product__link') || {}).href
        || '#';
      if (!groups[sid]) groups[sid] = [];
      groups[sid].push({
        card: card,
        handle: card.dataset.productHandle,
        colorLabel: card.dataset.colorLabel || '',
        url: url,
      });
    });

    Object.keys(groups).forEach(function (sid) {
      var items = groups[sid];
      if (items.length < 2) return;

      items.forEach(function (item) {
        var container = item.card.querySelector('[data-style-swatches]');
        if (!container) return;
        container.innerHTML = buildSwatches(items, item.handle);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after AJAX filter/pagination loads new products
  document.addEventListener('collection:products-loaded', init);
  document.addEventListener('collection:chrome-refreshed', init);
})();
